import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, EmptyState } from "../components/Section";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="gallery-page">
      <PageHeader eyebrow="LIFE OF THE COUNCIL" title="Gallery"
        subtitle="Moments of worship, teaching, and fellowship." />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {items.length === 0 ? <EmptyState /> : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {items.map((g) => (
                <div key={g.id} data-testid={`gallery-item-${g.id}`} className="aspect-square overflow-hidden border hairline rounded-lg group">
                  <img src={g.image_url} alt={g.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
